
export type TSupportedChains = {
    [key:string]: {
        api:string, 
        apiKey: string,
        gcr:string,
        rpc: string,
    }};

export const supportedChains: TSupportedChains = {

    // ==================== MAINNETS: ====================

    // arbitrum: {
    //     api: 'https://api.arbiscan.io/api',
    //     apiKey: arbitrumApiKey,
    //     gcr: '',
    //     rpc: 'https://arbitrum.drpc.org',
    // },
    // avalanche: {
    //     api: 'https://api.routescan.io/v2/network/mainnet/evm/43114/etherscan/api',
    //     apiKey: avalancheApiKey,
    //     gcr: '',
    //     rpc: 'https://avalanche-c-chain-rpc.publicnode.com',
    // },
    // base: {
    //     api: 'https://api.basescan.org/api',
    //     apiKey: baseApiKey,
    //     gcr: '',
    //     rpc: 'https://base-rpc.publicnode.com',
    // },
    ethereum: {
        api: 'https://api.etherscan.io/api',
        apiKey: '26FDQSKI2QCHG18NNX52YUR94C3M3MTI2Q',
        gcr: '0x8FEff3C72Cd120EAEC5da29Df3cD35198b7e249C',
        rpc: 'https://ethereum-rpc.publicnode.com',
    },
    // optimism: {
    //     api: 'https://api-optimistic.etherscan.io/api',
    //     apiKey: optimismApiKey,
    //     gcr: '',
    //     rpc: 'https://optimism-rpc.publicnode.com',
    // },
    polygon: {
        api: 'https://api.polygonscan.com/api',
        apiKey: '7I7A2QA3RPQE2VBKCJDMSA1YASG291IBQD',
        gcr: '0x470c20eBCA1F0Cc308f63beBE29fACC58692f0F7',
        rpc: 'https://1rpc.io/matic',
    },

    // ==================== TESTNETS: ====================

    // arbitrumSepolia: {
    //     api: 'https://api-sepolia.arbiscan.io/api',
    //     apiKey: arbitrumApiKey,
    //     gcr: '',
    //     rpc: 'https://arb-pokt.nodies.app',
    // },
    // avalancheFuji:{
    //     api: 'https://api.routescan.io/v2/network/testnet/evm/43113/etherscan',
    //     apiKey: avalancheApiKey,
    //     gcr: '',
    //     rpc: 'https://api.avax-test.network/ext/bc/C/rpc',
    // },
    // baseSepolia:{
    //     api:'https://api-sepolia.basescan.org/api',
    //     apiKey: baseApiKey,
    //     gcr: '',
    //     rpc: 'https://base-sepolia.blockpi.network/v1/rpc/public'
    // },
    // optimismSepolia:{
    //     api: 'https://api-sepolia-optimistic.etherscan.io/api',
    //     apiKey: optimismApiKey,
    //     gcr: '',
    //     rpc: 'https://optimism-sepolia.blockpi.network/v1/rpc/public',
    // },
    // sepolia : {
    //     api: "https://api-sepolia.etherscan.io/api",
    //     apiKey: etherumApiKey,
    //     gcr: "0x0f7B6173C4C914739954Be97Fa5f276f5a35ff62",
    //     rpc: 'https://ethereum-sepolia.blockpi.network/v1/rpc/public',
    // },
    // polygonMumbai: {
    //     api:'https://api-mumbai.polygonscan.com/api',
    //     apiKey: polygonApiKey,
    //     gcr: '',
    //     rpc: 'https://rpc.ankr.com/polygon_mumbai',
    // }
}

export type TChainName = keyof typeof supportedChains;